<template>
    <v-dialog v-model="show" width="500" class="dialog-delete">
        <v-card class="rounded-lg">
            <v-card-item>
                <v-card-title class="d-flex mb-4">
                    <h3>{{ title }}</h3>
                </v-card-title>
                <v-divider />
            </v-card-item>
            <v-card-text>
                <p class="text-body-1 mb-6">
                    This will delete the expert for you until you are invited again. Are you sure
                    you want to delete
                    <span class="font-weight-bold">"{{ itemName }}"</span>
                    ?
                </p>
                <div class="d-flex flex-row justify-end flex-gap-2 mb-3">
                    <ButtonComponent
                        :disabled="isDeleting"
                        variant="gray"
                        color="error"
                        name="expert-cancel-deletion-button"
                        @click="cancel"
                    >
                        Cancel
                    </ButtonComponent>
                    <ButtonComponent
                        variant="error"
                        prepend-icon="mdi-exit-to-app"
                        :loading="isDeleting"
                        name="expert-delete-button"
                        @click="confirm"
                    >
                        Leave
                    </ButtonComponent>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import ButtonComponent from '@/components/utils/buttons/ButtonComponent.vue';

export default {
    name: 'DialogLeave',
    components: { ButtonComponent },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        itemName: {
            type: String,
            required: true,
        },

        goBackBtnText: {
            type: String,
            required: false,
            default: 'Go Back',
        },
        isDeleting: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['update:modelValue', 'confirm', 'cancel', 'goBack'],
    computed: {
        show: {
            get() {
                return this.modelValue || false;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
        goBack() {
            this.$emit('goBack');
        },
    },
};
</script>

<style scoped></style>
